<template>
  <li class="promo-starting-bonus" v-if="promotionActive">
    <dyn-slot :slotData="slotData">
      <slot name="dynPromoStartingBonus"></slot>
    </dyn-slot>
  </li>
  <li v-else-if="isActivation">
      <slot name="txtStartingBonusActivation"></slot>
  </li>
</template>

<script>

import promoContext from '@/mixins/promoContext'

export default {
  name: 'StartingBonus',
  mixins: [promoContext],
  computed: {
    slotData () {
      return {
        promoAmount: this.promoAmount
      }
    },
    baseAmount: function () {
      return this.isActivation ? 10 : 0
    },
    promotionActive: function () {
      return this.promoAmount > this.baseAmount
    },
    activeCoupon: function () {
      return this.includeCoupons && this.couponRedeemed && this.couponTypeStartingBonus === true
    },
    isActivation: function () {
      return this.frontendContext === 'activation'
    },
    promoAmount: function () {
      let promoAmountSum = 0
      this.creditIncentives.filter(incentive => incentive.targetEntity === 'TARIFF' && incentive.targetFee === 'ONE_TIME_FEE').forEach(incentive => {
        // Just sum up incentives with the same duration
        if (incentive.discount) {
          promoAmountSum += parseInt(incentive.discount / 100, 10)
        }
      })
      // Add coupon with same duration on top
      if (this.activeCoupon) {
        promoAmountSum += this.couponDiscountAmount !== null && this.couponDiscountAmount !== undefined ? parseInt(this.couponDiscountAmount / 100, 10) : 0
      }
      return promoAmountSum
    }
  },
  props: {
    includeCoupons: {
      type: Boolean,
      default: false
    }
  },
  mounted () { }
}
</script>
